export class UnrecognizedValueError extends Error {
  constructor(m: string) {
    super(m);
    this.name = "UnrecognizedValueError";
  }
}
